import type { ErrorResponse } from '@/types/common';
import type { QuestionnaireFormRequest, QuestionnaireFormResponse } from '@/types/questionnaire';

export const getQuestionnairesAPI = () => {
	return useRequest<Array<QuestionnaireFormResponse>>(FORM_ENDPOINT, REQUEST_METHOD.GET);
};

export const getQuestionnaireByIdAPI = (formId: number) => {
	return useRequest<QuestionnaireFormResponse, ErrorResponse>(`${FORM_ENDPOINT}/${formId}`, REQUEST_METHOD.GET);
};

export const deleteQuestionnaireByIdAPI = (id: number) => {
	return useRequest(`${FORM_ENDPOINT}/${id}`, REQUEST_METHOD.DELETE);
};

export const postCreateQuestionnaireForm = (payload: QuestionnaireFormRequest) => {
	return useRequest<QuestionnaireFormResponse, ErrorResponse>(FORM_ENDPOINT, REQUEST_METHOD.POST, payload);
};

export const patchUpdateQuestionnaireForm = (formId: number, payload: Partial<QuestionnaireFormRequest>) => {
	return useRequest<QuestionnaireFormResponse, ErrorResponse>(`${FORM_ENDPOINT}/${formId}`, REQUEST_METHOD.PATCH, payload);
};